import { render, staticRenderFns } from "./ElementWrapper.vue?vue&type=template&id=84dc4db8&scoped=true&"
import script from "./ElementWrapper.vue?vue&type=script&lang=js&"
export * from "./ElementWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ElementWrapper.vue?vue&type=style&index=0&id=84dc4db8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84dc4db8",
  null
  
)

export default component.exports